import Config from '@app/dev/config/main';
import { Personal } from './pieces/Personal';
import { Contact } from './pieces/Contact';
import { Credential } from './pieces/Credential';
import { RegistrationTermsAndConditions } from './pieces/RegistrationTermsAndConditions';

const personal = {
  component: Personal,
  validate: (form) => {
    const formErrors = {};

    if (!form.firstName) {
      formErrors.firstName = 'Field is required';
    } else if (!/^[A-Za-z]+$/.test(form.firstName)) {
      formErrors.firstName = 'Only letters are allowed';
    }

    if (!form.lastName) {
      formErrors.lastName = 'Field is required';
    } else if (!/^[A-Za-z]+$/.test(form.lastName)) {
      formErrors.lastName = 'Only letters are allowed';
    }

    if (!form.birthDate) formErrors.birthDate = 'Field is required';

    return formErrors;
  },
};
const contact = {
  component: Contact,
  validate: (form) => {
    const formErrors = {

    };

    if (!form.email) {
      formErrors.email = 'Field is required';
    } else if (!(/^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/.test(form.email))) {
      formErrors.email = 'Invalid email format';
    }
    if (!form.phoneNumber.phone) {
      formErrors.phoneNumber = 'Field is required';
    } else if (!/^\d+$/.test(form?.phoneNumber?.phone)) {
      formErrors.phoneNumber = 'Phone number must contain digits only';
    }

    if (!form.street) formErrors.street = 'Field is required';
    if (!form.city) formErrors.city = 'Field is required';
    if (!form.zipCode) formErrors.zipCode = 'Field is required';

    return formErrors;
  },
};

const credential = {
  component: Credential,
  validate: (form) => {
    const formErrors = {};

    if (!form.userName) formErrors.userName = 'Field is required';
    if (!form.password) formErrors.password = 'Field is required';
    if (!form.confirmPassword) formErrors.confirmPassword = 'Field is required';
    if (form.password !== form.confirmPassword) formErrors.password = "Password Did'nt match ";

    return formErrors;
  },
};

const registrationTermsAndConditions = {
  component: RegistrationTermsAndConditions,
  validate: (form) => {
    const formErrors = {};

    if (!form.rull18) formErrors.rull18 = 'Must be checked';
    if (!form.termsAndConditions) formErrors.termsAndConditions = 'Must be checked';

    return formErrors;
  },
};
const stepMap = {
  personal_information: personal,
  contact_information: contact,
  credential_information: credential,
  registrationTermsAndConditions_information: registrationTermsAndConditions,
};

export const getStepsList = () => (
  Config.registrationFormConfigs.registrationFormSteps.map((step) => ({ name: step.name, step: stepMap[step.name] })).filter(Boolean)
);
